<script setup lang="ts">
import { computed, toRefs, watch, type PropType } from 'vue';
import { StatisticsKind } from '../enums';
import { useInfoModal } from '@maximap-base';

const props = defineProps({
  statisticsKind: {
    type: String as PropType<StatisticsKind>,
    required: true
  },
  componentName: {
    type: String,
    required: true
  }
});

const { statisticsKind, componentName } = toRefs(props);

const moduleName = computed(() =>
  statisticsKind.value === StatisticsKind.DECISION_SUPPORT ? 'decisionSupport' : 'statistics'
);
const infoContentTitle = computed(() => `${moduleName.value}.label.${componentName.value}InfoTitle`);
const infoContentKey = computed(() => `maximap.statistics.${statisticsKind.value}.${componentName.value}.info`);

const { openInfoModal, loadHtmlContent } = useInfoModal(infoContentKey.value, infoContentTitle.value);

watch(infoContentKey, () => {
  loadHtmlContent(infoContentKey.value);
});
</script>

<template>
  <v-icon
    icon="mdi-information"
    id="icon"
    color="blue"
    class="ml-2"
    size="x-large"
    @click.stop.prevent="openInfoModal">
  </v-icon>
</template>
